import { ReactNode } from 'react'

interface ContainerGroupFieldProps {
    children: ReactNode
    tittleGroup: string
    className?: string
    onlyOneField?: boolean
}

export const ContainerGroupField = ({
    children,
    tittleGroup,
    className,
    onlyOneField
}: ContainerGroupFieldProps): JSX.Element => {
    return (
        <div>
            <p className="pt-2 text-lg font-bold text-left uppercase text-primary dark:text-primary-dark">
                {tittleGroup}
            </p>
            <div
                className={`grid w-full pt-3 border-t border-t-primary dark:border-t-primary-dark ${onlyOneField ? '' : 'md:grid-cols-2 gap-5'} ${className}`}
            >
                {children}
            </div>
        </div>
    )
}
